import { useRef } from 'react';
import PropTypes from 'prop-types';
import { useButton } from 'react-aria';

import defaultAriaProps from 'client/utils/constants/ariaPropTypes';

import styles from './PageButton.module.scss';

const NextPage = ({ children, current, ...props }) => {
    const ref = useRef();
    const { buttonProps } = useButton({
        ...props,
        elementType: 'a'
    }, ref);

    return (
        <div
            className={[
                'govuk-pagination__item',
                current ? 'govuk-pagination__item--current' : null,
                current ? styles.current : null,
                styles.item
            ].join(' ')}
            {...buttonProps}
        >
            <a
                aria-label={'Page ' + children}
                className={[
                    'govuk-link govuk-pagination__link',
                    styles.link
                ].join(' ')}
            >
                {children}
            </a>
        </div>
    );
};

NextPage.propTypes = {
    ...defaultAriaProps,
    children: PropTypes.number,
    onPress: PropTypes.func,
    current: PropTypes.bool
};

export default NextPage;
